/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect } from 'react';
import styles from './styles.module.scss';

import apiMenu from '../../../api/Menus/mobile';

import { ReactComponent as Close } from '../../../assets/icons/icon-close.svg';
import { ReactComponent as Mexico } from '../../../assets/icons/icon-mexico.svg';
import { ReactComponent as ArrowDown } from '../../../assets/icons/icon-arrow-down.svg';
import { SearchBoxMobile } from '../Search';
import LinkWrap from '../../Wraps/LinkWrap';
import LinkLang from '../../Wraps/LinkLang';

import { spanish } from '../../../config/config';

const Language = () => (
  <div className={styles.language}>
    <LinkLang to="/location">
      <Mexico />
      <b>{spanish ? 'México' : 'Mexico'}</b>
      <p>{spanish ? 'ES' : 'EN'}</p>
      <ArrowDown />
    </LinkLang>
  </div>
);

const Footer = ({ data }) => (
  <div className={styles.menuFooter}>
    <h5>{spanish ? 'CONTÁCTANOS' : 'CONTACT US'}</h5>
    <div className={styles.menuFooterContent}>
      <p>{data?.Address}</p>
      <b>{spanish ? data?.CustomerCareSpanish : data?.CustomerCareEnglish}</b>
      <p>{data?.Phone}</p>
      <a href={`mailto:${data?.Email}`}>{data?.Email}</a>
    </div>
  </div>
);

const SectionButton = ({ title, children }) => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  return (
    <div className={styles.menuSection}>
      <button type="button" onClick={toggle}>
        <p>{title}</p>
        <ArrowDown />
      </button>
      {open ? children : ''}
    </div>
  );
};

const Menu = ({ active, toggle }) => {
  const [login, setLogin] = useState(null);
  const [categories, setCategories] = useState([]);
  const [joinLinks, setJoinLinks] = useState([]);
  const [aboutLinks, setAboutLinks] = useState([]);
  const [address, setAddress] = useState([]);
  useEffect(async () => {
    setLogin(await apiMenu.getLogin());
    setCategories(await apiMenu.getCategories());
    setJoinLinks(await apiMenu.getJoin());
    setAboutLinks(await apiMenu.getAbout());
    setAddress(await apiMenu.getAddress());
  }, []);
  const orderedList = categories?.sort((a, b) => a?.Position - b?.Position);
  return (
    <div className={`${styles.menu} ${active ? styles.menuActive : ''}`}>
      <div className={styles.menuContainer}>
        <div className={styles.menuContent}>
          <button type="button" className={styles.menuClose} onClick={toggle}>
            <Close />
          </button>
          <div className={styles.menuSearch}>
            <SearchBoxMobile close={toggle} />
          </div>
          <div className={styles.menuLogin}>
            {login && (
              <a
                href={login?.LoginURL}
                target="_blank"
                rel="noopener noreferrer"
              >
                {spanish ? login?.LoginSpanish : login?.LoginEnglish}
              </a>
            )}
          </div>
          <SectionButton title={spanish ? 'COMPRAR' : 'SHOP'}>
            <div className={styles.menuSectionContent} onClick={toggle}>
              {categories &&
                orderedList &&
                orderedList?.map((item, key) => (
                  <LinkLang
                    to={`/category/${item?.SLUG}`}
                    key={key}
                    state={{
                      categoryId: item?.categoryID,
                      categoryName: item.NameSpanish,
                    }}
                  >
                    {spanish ? item?.NameSpanish : item?.NameEnglish}
                  </LinkLang>
                ))}
            </div>
          </SectionButton>
          <SectionButton title={spanish ? 'UNIRSE' : 'JOIN'}>
            <div className={styles.menuSectionContent} onClick={toggle}>
              {joinLinks &&
                joinLinks?.map((item, key) => (
                  <LinkWrap
                    to={item?.LinkTo}
                    isExternal={item?.External}
                    key={key}
                  >
                    {spanish ? item?.NameSpanish : item?.NameEnglish}
                  </LinkWrap>
                ))}
            </div>
          </SectionButton>
          <SectionButton title={spanish ? 'ACERCA DE' : 'ABOUT'}>
            <div className={styles.menuSectionContent} onClick={toggle}>
              {aboutLinks &&
                aboutLinks?.map((item, key) => (
                  <LinkWrap
                    to={item?.LinkTo}
                    isExternal={item?.External}
                    key={key}
                  >
                    {spanish ? item?.NameSpanish : item?.NameEnglish}
                  </LinkWrap>
                ))}
            </div>
          </SectionButton>
          <div className={styles.menuLanguage}>
            <Language />
          </div>
        </div>
        {address && <Footer data={address} />}
      </div>
    </div>
  );
};

export default Menu;
